export function clog(...xs: any[]) {
    let s = ""
    for (const [i, x] of indexed(xs)) {
        if (i > 0)
            s += ' '
        s += x
    }
    console.log(s)
}

export function* indexed<T>(xs: Iterable<T>): Iterable<[number, T]> {
    let i = 0
    for (const x of xs) {
        yield [i, x]
    }
}
